import React from "react";

import { TypeInsignia, TypePrius } from "@at/design-system-foundation";

import { dataAttrGUI, dataAttrTestId } from "@at/formatter-utils";

import * as Styled from "./commission-disclosure.styled";
import { setLeasingModal } from "../../../../../contexts/leasing/actions/leasing.actions";
import { useLeasingDispatchContext } from "../../../../../contexts/leasing/context/leasing.context";
import { LeasingModals } from "../../../../../contexts/leasing/types/leasing.types";
import { useTracking } from "../../../../../utils/tracking/use-tracking";
import { LeasingProductBordered } from "../../leasing-contract-customiser.styled";

export const CommissionDisclosure = () => {
  const dispatch = useLeasingDispatchContext();

  const { trackEvent } = useTracking();
  const handleCommissionDisclosureModal = () => {
    dispatch(
      setLeasingModal({
        show: true,
        type: LeasingModals.COMMISSION_DISCLOSURE,
        title: "Commission Disclosure",
      }),
    );

    trackEvent({ trackingLabel: "learn-more-commissions-disclosure" });
  };

  return (
    <LeasingProductBordered>
      <TypeInsignia weight="400" as="h2">
        Commission disclosure
      </TypeInsignia>
      <TypePrius as="p" {...{ [dataAttrTestId]: "commission-content" }}>
        As a credit broker, Autorama UK Limited will find you the best price
        from a panel of funders. Autorama will earn a commission from the funder
        on a completed credit agreement, but this will never influence which
        funder is chosen. We always show you the cheapest monthly price.
      </TypePrius>
      <Styled.LearnMoreCommissionsLink
        routerLink={false}
        renderAsButton={true}
        onClick={handleCommissionDisclosureModal}
        {...{ [dataAttrGUI]: "commission-disclosure-modal-button" }}
      >
        Learn more about commissions
      </Styled.LearnMoreCommissionsLink>
    </LeasingProductBordered>
  );
};
